module.exports = __webpack_public_path__ + "img/the.289cdf46.png";